export interface ChildOnboardingSituation {
  type: UnderageOnboardingLegalGuardianshipStatus;
  name: string;
  documents?: ChildOnboardingSituationDocument[];
  isValid: boolean;
}

export enum UnderageOnboardingLegalGuardianshipStatus {
  MARRIED_SAME_NAME = 'MARRIED_SAME_NAME',
  MARRIED_DIFFERENT_NAME = 'MARRIED_DIFFERENT_NAME',
  UNMARRIED_COUPLE = 'UNMARRIED_COUPLE',
  SINGLE_PARENT = 'SINGLE_PARENT',
  WIDOWED = 'WIDOWED',
  UNMARRIED_PARTNER_DECEASED = 'UNMARRIED_PARTNER_DECEASED',
}

export interface ChildOnboardingSituationDocument {
  type: UnderageOnboardingLegitimizationDocument;
  name: string;
}

export enum UnderageOnboardingLegitimizationDocument {
  BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE',
  MARRIAGE_CERTIFICATE = 'MARRIAGE_CERTIFICATE',
  CUSTODY_DECLARATION = 'CUSTODY_DECLARATION',
}
